import styled from 'styled-components';
import Caption from '../Caption';
export var StyledLoading = styled.div.withConfig({
  displayName: "Loadingstyles__StyledLoading",
  componentId: "sc-1jgnm4t-0"
})(["display:flex;justify-content:center;align-items:center;color:var(--dentsu-loading-spinner-color,var(--dentsu-color-n350));height:50vh;flex-direction:column;text-align:center;"]);
export var StyledLoadingContent = styled(Caption).attrs({
  isSecondary: true
}).withConfig({
  displayName: "Loadingstyles__StyledLoadingContent",
  componentId: "sc-1jgnm4t-1"
})(["margin-top:16px;"]);